import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";

import { router } from "./router";
import "./styles/global.css";

/**
 * Tankly — the staff back-office (blueprint §5.2).
 *
 * NOT an organization. A separate app, a separate auth gate, a separate cookie, and — behind
 * it — a separate, audited database role. It shares the customer app's brand and nothing
 * else, and it deliberately does not share a line of its code.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The staff console reads ACROSS TENANTS and every read is audited. Refetching on
      // every window focus would fill the append-only audit log with rows nobody asked for,
      // and bury the ones somebody did.
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
});

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
